export enum SubscriptionTypeEnum {
  BARTENDER_ESSENTIAL = 'BARTENDER_ESSENTIAL',
  BARTENDER_STANDARD = 'BARTENDER_STANDARD',
  BARTENDER_PREMIUM = 'BARTENDER_PREMIUM',
}
